import React, { ChangeEvent, FormEvent } from 'react';
import { Typography, makeStyles, TextField, Grid, Button, InputLabel, Theme } from '@material-ui/core';
import { useAppState } from '../../../state';
import { useIntl } from 'react-intl';

const famousAdventurer = [
  'Leif Eriksson',
  'Marco Polo',
  'Ferdinand Magellan',
  'Captain James Cook',
  'Isabella Bird',
  'Amelia Earhart',
  'Harriet Chalmers Adams',
  'Louise Arner Boyd',
  'Junko Tabei',
  'Jeanne Baret',
  'Charles Lindbergh',
].sort(() => Math.random() - 0.5)[0];

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '0.25em',
  },
  marginTitleContainer: {
    marginBottom: '1.7em',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1.5em 0 3.5em',
    '& div:not(:last-child)': {
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1.5em 0 2em',
    },
  },
  textFieldContainer: {
    width: '100%',
  },
  continueButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

interface RoomNameScreenProps {
  name: string;
  roomName: string;
  setName: (name: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

const isRoomNameValid = (roomName: string): boolean => {
  const parsedName = roomName.split('@');
  return parsedName.length === 2;
};

export default function RoomNameScreen({ name, roomName, setName, handleSubmit }: RoomNameScreenProps) {
  const classes = useStyles();
  const { user } = useAppState();
  const { formatMessage } = useIntl();

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const hasUsername = !window.location.search.includes('customIdentity=true') && user?.displayName;

  if (!isRoomNameValid(roomName)) {
    return roomName ? (
      <Typography variant="h5">Error: Room "{roomName}" not found</Typography>
    ) : (
      <Typography variant="h5">Error: Room name is missing</Typography>
    );
  }

  return (
    <>
      <Typography variant="h5">{formatMessage({ id: 'room_name_screen.title' })}</Typography>
      <Typography variant="body1">{formatMessage({ id: 'room_name_screen.description' })}</Typography>

      <form onSubmit={handleSubmit}>
        <div className={classes.inputContainer}>
          {!hasUsername && (
            <div className={classes.textFieldContainer}>
              <InputLabel shrink htmlFor="input-user-name">
                {formatMessage({ id: 'room_name_screen.your_name' })}
              </InputLabel>
              <TextField
                placeholder={famousAdventurer}
                id="input-user-name"
                variant="outlined"
                fullWidth
                size="small"
                value={name}
                onChange={handleNameChange}
              />
            </div>
          )}
        </div>
        <Grid container justifyContent="flex-end">
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={!name || !roomName}
            className={classes.continueButton}
          >
            {formatMessage({ id: 'room_name_screen.continue_button' })}
          </Button>
        </Grid>
      </form>
    </>
  );
}
